import { IconProps } from '../../types';
import { useTheme } from 'styled-components';

// --------------------------------------------------------------------------

const Clock = ({
  height = 65,
  width = 65,
  colorPrimary,
  colorSecondary,
  className,
}: IconProps) => {
  const { midwestColors } = useTheme();
  const primary = colorPrimary ?? midwestColors.identityBrandPrimaryHeavy;
  const secondary =
    colorSecondary ?? midwestColors.semanticColorSentimentInfoMedium;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 65 65"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M33.2516 3.77474C17.1844 3.77474 4.11328 16.8458 4.11328 32.913C4.11328 48.9802 17.1844 62.0547 33.2516 62.0547C49.3187 62.0547 62.3898 48.9802 62.3898 32.913C62.3898 16.8458 49.3187 3.77474 33.2516 3.77474ZM33.2516 54.9453C21.1047 54.9453 11.2227 45.0599 11.2227 32.913C11.2227 20.7661 21.1047 10.8841 33.2516 10.8841C45.3984 10.8841 55.2805 20.7661 55.2805 32.913C55.2805 45.0599 45.3984 54.9453 33.2516 54.9453Z"
        fill={secondary}
        className="fill-secondary"
      />
      <path
        d="M45.8792 32.4052H35.4047C35.2151 31.5927 34.5719 30.9495 33.7594 30.7599V13.176C33.7594 12.8951 33.5326 12.6682 33.2516 12.6682C32.9706 12.6682 32.7438 12.8951 32.7438 13.176V30.7599C31.7654 30.9867 31.0375 31.8669 31.0375 32.913C31.0375 34.1352 32.0294 35.1271 33.2516 35.1271C34.2977 35.1271 35.1779 34.3992 35.4047 33.4208H45.8792C46.1602 33.4208 46.387 33.194 46.387 32.913C46.387 32.632 46.1602 32.4052 45.8792 32.4052ZM33.2516 34.1115C32.5914 34.1115 32.0531 33.5732 32.0531 32.913C32.0531 32.2529 32.5914 31.7146 33.2516 31.7146C33.9117 31.7146 34.45 32.2529 34.45 32.913C34.45 33.5732 33.9117 34.1115 33.2516 34.1115Z"
        fill={primary}
        className="fill-primary"
      />
      <path
        d="M33.2516 53.1578C32.9706 53.1578 32.7438 52.931 32.7438 52.65V50.2396C32.7438 49.9586 32.9706 49.7318 33.2516 49.7318C33.5326 49.7318 33.7594 49.9586 33.7594 50.2396V52.65C33.7594 52.931 33.5326 53.1578 33.2516 53.1578Z"
        fill={primary}
        className="fill-primary"
      />
      <path
        d="M52.9919 33.4208H50.5815C50.3005 33.4208 50.0737 33.194 50.0737 32.913C50.0737 32.632 50.3005 32.4052 50.5815 32.4052H52.9919C53.2729 32.4052 53.4997 32.632 53.4997 32.913C53.4997 33.194 53.2729 33.4208 52.9919 33.4208Z"
        fill={primary}
        className="fill-primary"
      />
      <path
        d="M15.925 33.4208H13.5146C13.2336 33.4208 13.0068 33.194 13.0068 32.913C13.0068 32.632 13.2336 32.4052 13.5146 32.4052H15.925C16.206 32.4052 16.4328 32.632 16.4328 32.913C16.4328 33.194 16.206 33.4208 15.925 33.4208Z"
        fill={primary}
        className="fill-primary"
      />
      <path
        d="M45.5068 21.169C45.3781 21.169 45.2461 21.1182 45.1479 21.0201C44.9482 20.8203 44.9482 20.4987 45.1479 20.3023L46.8508 18.5995C47.0505 18.3997 47.3721 18.3997 47.5685 18.5995C47.7648 18.7992 47.7682 19.1208 47.5685 19.3172L45.8656 21.0201C45.7674 21.1182 45.6354 21.169 45.5068 21.169Z"
        fill={primary}
        className="fill-primary"
      />
      <path
        d="M19.2969 47.3789C19.1682 47.3789 19.0362 47.3281 18.938 47.2299C18.7383 47.0302 18.7383 46.7086 18.938 46.5122L20.6409 44.8094C20.8406 44.6096 21.1622 44.6096 21.3586 44.8094C21.5583 45.0091 21.5583 45.3307 21.3586 45.5271L19.6557 47.2299C19.5576 47.3281 19.4255 47.3789 19.2969 47.3789Z"
        fill={primary}
        className="fill-primary"
      />
      <path
        d="M47.2096 47.3789C47.081 47.3789 46.949 47.3281 46.8508 47.2299L45.1479 45.5271C44.9482 45.3273 44.9482 45.0057 45.1479 44.8094C45.3477 44.6096 45.6693 44.6096 45.8656 44.8094L47.5685 46.5122C47.7682 46.712 47.7682 47.0336 47.5685 47.2299C47.4703 47.3281 47.3383 47.3789 47.2096 47.3789Z"
        fill={primary}
        className="fill-primary"
      />
      <path
        d="M20.9997 21.169C20.8711 21.169 20.7391 21.1182 20.6409 21.0201L18.938 19.3172C18.7383 19.1174 18.7383 18.7958 18.938 18.5995C19.1344 18.3997 19.4594 18.3997 19.6557 18.5995L21.3586 20.3023C21.5583 20.5021 21.5583 20.8237 21.3586 21.0201C21.2604 21.1182 21.1284 21.169 20.9997 21.169Z"
        fill={primary}
        className="fill-primary"
      />
    </svg>
  );
};

export default Clock;
